import React from 'react';
import withTranslation from '../../hoc/withTranslation';
import Error from '../../components/common/Error/Error';
import Loading from '../../components/common/Loading/Loading';
import style from '../../styles/styles';
import { connect } from 'react-redux';
import { fetchApp } from '../../store/apps/actions';
import PropTypes from 'prop-types';
import { Paper } from 'material-ui';
import styles from '../reportsubjects/AddReportSubjectPage/AddReportSubjectPage.css';
import Subheader from 'material-ui/Subheader';
import AccessTokenForm from '../../components/accessToken/AccessTokenForm';
import { postAccessToken } from '../../store/accessTokens/actions';
import { SETTING_PAGE } from '../../constants/routes';

class AddAccessTokenPage extends React.Component {
    static propTypes = {
        app: PropTypes.object,
        postAccessToken: PropTypes.func,
        sending: PropTypes.bool,
    };

    componentWillMount() {
        this.fetchApplication();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.sending && !nextProps.sending && nextProps.accessTokenError === null) {
            try {
                this.props.history.push(SETTING_PAGE.replace(':appId', this.props.app.id));
            } catch (e) {
                console.error(e);
            }
        }
    }

    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id);
            }
        }
    }

    handleFormSubmit = async (formProps) => {
        await this.props.postAccessToken(this.props.app.id, formProps);
    };

    render() {
        if (this.props.error) {
            return (
                <Error
                    title={this.props.t('generic.error')}
                    subtitle={this.props.t('generic.error_loading')}
                    paper={true}
                />
            );
        } else if (this.props.loading || !this.props.app) {
            return <Loading paper={false} />;
        } else {
            return (
                <div>
                    <h3 style={style.navigation}>
                        {this.props.t(
                            'module.access_token.access_token_add',
                            { name: this.props.app.name },
                        )}
                    </h3>
                    <div className="row">
                        <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                            <Paper style={styles.editBox}>
                                <Subheader style={style.subHeader}>
                                    {this.props.t('module.access_token.new_access_token')}
                                </Subheader>
                                <div style={style.paper}>
                                    <AccessTokenForm
                                        onSubmit={this.handleFormSubmit}
                                        submitting={this.props.sending}
                                    />
                                </div>
                                <div style={style.clear} />
                            </Paper>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

function mapStateToProps(state, ownProps) {
    return {
        loading: state.apps.pending,
        error: state.apps.error,
        accessTokenError: state.accessTokens.error,
        sending: state.accessTokens.sending,
        app: state.apps.currentApplication,
    };
}

export default connect(mapStateToProps, {
    fetchApp,
    postAccessToken,
})(withTranslation(AddAccessTokenPage));



// WEBPACK FOOTER //
// src/containers/accessToken/AddAccessTokenPage.js